/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */

/**
 * Created by richardwilliams on 5/28/15.
 */
'use strict';
function PackageCollaboratorsViewController(
    this: JS5Object,
    _: JS5Object,
    $filter:JS5Function,
    $location:JS5Object,
    $q:JS5Object,
    $routeParams:JS5Object,
    $timeout: JS5Function,
    CollaboratorViewDataTransformer:JS5Object,
    ModalService:JS5Object,
    NavbarUtilService:JS5Object,
    NotificationService:JS5Object,
    PackageLiveClipViewService: JS5Object,
    PackageResourceFactory:JS5Object,
    PackageUtilService:JS5Object,
    PermissionsService:JS5Object,
    SearchFilterService: JS5Object
) {
    let PACKAGE_COLLABORATORS_VIEW_STATE = 'PACKAGE_COLLABORATORS_VIEW_STATE';
    let CLIP_COLLABORATORS_VIEW_STATE = 'CLIP_COLLABORATORS_VIEW_STATE';
    let CLIP_TABS_VIEW_STATE = 'PACKAGE_VIDEO_CLIPS_VIEW_STATE';

    let originalCollaborators: JS5Object = [];
    this.collaboratorData = {actors: [], crew: []};

    let queryId: number;
    let availableActorsQueryParam: string;

    let setQueryProperties = () => {
        if (this.isClipCollaborators) {
            queryId = this.packageObject.id;
            availableActorsQueryParam = 'actors';
        } else {
            queryId = $routeParams.id;
            availableActorsQueryParam = 'actorsByContent';
        }
    };

    let getSavedRolesMap = () => {
        let roleMap: JS5Object = {};
        _.forEach(this.collaboratorData.crew, (crewMember: JS5Object) => {
            let roles = roleMap[crewMember.collaborator.id];
            if (!roles) {
                roles = [];
                roleMap[crewMember.collaborator.id] = roles;
            }
            roles.push(crewMember.role);
        });
        return roleMap;
    };

    let filterAvailableCollaborators = (availableCollaborators: JS5Object[]) => {
        let filteredResults: JS5Object[] = [];
        let activeCollabs = this.collaboratorData[this.currentTab.toLowerCase()];
        angular.forEach(availableCollaborators, (collab) => {
            let collabAlreadyAdded = $filter('filter')(activeCollabs, {id: collab.id}).length !== 0;
            if (!collabAlreadyAdded) {
                filteredResults.push(collab);
            }
        });
        return filteredResults;
    };

    let generateRoles = (newCollabs: JS5Object) => {
        if (this.currentTab === 'Actors') {
            return newCollabs;
        }

        let collaboratorRoles: JS5Object[] = [];

        let savedRoles = getSavedRolesMap();
        _.forEach(newCollabs, (collaborator: JS5Object) => {
            angular.forEach(collaborator.collaboratorRoleSelection, (memberRole) => {
                if (savedRoles[collaborator.id] && savedRoles[collaborator.id].indexOf(memberRole.name) > -1) {
                    return;
                }
                collaboratorRoles.push({
                    type: 'Crew',
                    packageId: $routeParams.id,
                    role: memberRole.name,
                    collaborator: collaborator
                });

            });
            delete collaborator.collaboratorRoleSelection;
            delete collaborator.collaboratorRoleDropdownElements;
        });

        return collaboratorRoles;
    };

    let openConfirmModal = (messageText: string, title: string, handler: JS5Function) => {
        ModalService.showMessageModal({
            messageText: messageText,
            pullCancelLeft: true,
            title: title,
            windowClass: 'confirm-modal-sm',
            showOK: true
        }, handler);
    };

    let buildCollaboratorsMap = (collaborators: JS5Object[]) => {
        let result: JS5Object = {
            actors: [],
            crew: [],
            disabled: {
                actors: [],
                crew: []
            }
        };
        _.forEach(collaborators, (item: JS5Object) => {
            let typeKey = item.type === 'Actor' ? 'actors' : 'crew';
            if (item.disabled) {
                result.disabled[typeKey].push(item);
                this.disabledFound = true;
            }
            else {
                result[typeKey].push(item);
            }
        });
        return result;
    };

    let handleGridDataQuery = (collabs: JS5Object[]) => {
        this.selectedRows = [];
        this.savedCollaboratorsMap = buildCollaboratorsMap(collabs);
        this.collaboratorData = {
            actors: this.savedCollaboratorsMap.actors.concat(this.savedCollaboratorsMap.disabled.actors),
            crew: this.savedCollaboratorsMap.crew.concat(this.savedCollaboratorsMap.disabled.crew)
        };
        originalCollaborators = angular.copy(this.collaboratorData);
        this.activateTab($location.search().subView || 'Actors');
    };

    let getEditData = () => {
        this.loadingIndicator.show = true;
        let viewState = this.isClipCollaborators ?
            CLIP_COLLABORATORS_VIEW_STATE :
            PACKAGE_COLLABORATORS_VIEW_STATE;

        let promises: JS5Object = {
            savedActors: PackageResourceFactory.query({id: queryId, sub: 'actors'}).$promise,
            availableActors: PackageResourceFactory.query({id: $routeParams.id, sub: availableActorsQueryParam}).$promise,
            clipWrite: PermissionsService.canWrite(CLIP_TABS_VIEW_STATE),
            readPerms: PermissionsService.canRead(viewState),
            writePerms: PermissionsService.canWrite(viewState)
        };

        if (!this.isClipCollaborators) {
            promises.savedCrew = PackageResourceFactory.query({id: queryId, sub: 'crew'}).$promise;
        }

        $q.all(promises).then((editData: JS5Object) => {
            if (editData.readPerms || editData.clipWrite) {
                if (this.isClipCollaborators) {
                    handleGridDataQuery(editData.savedActors);
                }
                else {
                    handleGridDataQuery(editData.savedActors.concat(editData.savedCrew));
                }
                this.availableCollaboratorsMap = buildCollaboratorsMap(editData.availableActors);

                this.hasWrite = editData.writePerms && (!this.isClipCollaborators || (this.isClipCollaborators && editData.clipWrite));
            }
            this.loadingIndicator.show = false;
        });
    };

    this.currentGridOptions = {
        selectionRowHeaderColName: 'checkMarkRowHeaderCol',
        rowSelection: true,
        enableRowHeaderSelection: false,
        enableSelectAll: true,
        enableColumnResizing: true,
        enablePaginationControls: false,
        useExternalPagination: false,
        enableColumnMenus: false,
        enableFullRowSelection: true,
        rowHeight: 26,
        multiSelect: true,
        columnDefs: CollaboratorViewDataTransformer.actorsColumns,
        onRegisterApi: (gridApi: JS5Object) => {
            this.gridApi = gridApi;
            gridApi.selection.on.rowSelectionChanged(null, this.gridRowSelectionChangedHandler);
        },
        rowTemplate: `<div ng-repeat="(colRenderIndex, col) in colContainer.renderedColumns track by col.uid" class="ui-grid-cell" ui-grid-cell></div>`
    };

    this.activateTab = (tab: JS5Object) => {
        this.currentTab = tab;
        let activeCollectionKey = this.currentTab.toLowerCase();
        let columnDefKey = `${activeCollectionKey}Columns`;
        this.roleTabs[activeCollectionKey] = true;

        if (!this.isClipCollaborators) {
            $location.search('subView', this.currentTab);
        }

        if(this.savedCollaboratorsMap && this.savedCollaboratorsMap[activeCollectionKey]) {
            let data = this.savedCollaboratorsMap[activeCollectionKey].concat(this.savedCollaboratorsMap.disabled[activeCollectionKey]);
            this.currentGridOptions.columnDefs = CollaboratorViewDataTransformer[columnDefKey];
            this.currentGridOptions.data = data;
            this.gridDataCopy = angular.copy(this.currentGridOptions.data);
        }

        this.filter($location.search().searchText);
    };

    this.openAddCollaboratorModal = (showDisabled: JS5Object) => {
        let typeKey = this.currentTab.toLowerCase();
        if (this.currentTab === 'Actors') {
            let activeCollection;

            let disabledCollection = this.availableCollaboratorsMap.disabled.actors;
            let enabledCollection = this.availableCollaboratorsMap.actors;

            if (this.isClipCollaborators) {
                activeCollection = disabledCollection.concat(enabledCollection);
            } else if (showDisabled) {
                activeCollection = disabledCollection;
            } else {
                activeCollection = enabledCollection;
            }
            ModalService.showAddCollaboratorModal(filterAvailableCollaborators(activeCollection), typeKey, this.handleNewSelection, undefined);
        } else {
            ModalService.showAddCollaboratorModal([], typeKey, this.handleNewSelection, getSavedRolesMap());
        }
    };


    this.addCollaborator = () => {
        if(!this.isClipCollaborators && this.packageObject.content.type === 'Series' && !this.packageObject.season) {
            NotificationService.createWarningNotification('Before adding a collaborator, a season must be selected on the package.');
        }
        else {
            this.openAddCollaboratorModal(false);
        }
    };

    this.addDisabledCollaborator = () => {
        if(!this.isClipCollaborators && this.packageObject.content.type === 'Series' && !this.packageObject.season) {
            NotificationService.createWarningNotification('Before adding a collaborator, a season must be selected on the package.');
        }
        else {
            this.openAddCollaboratorModal(true);
        }
    };

    this.deleteCollaborator = () => {
        let removeCollaborators = () => {
            _.forEach(this.selectedRows, (selectedCollaborator: JS5Object) => {
                for(let i=0; i < this.collaboratorData[this.currentTab.toLowerCase()].length; i++) {
                    if(selectedCollaborator.id === this.collaboratorData[this.currentTab.toLowerCase()][i].id) {
                        this.collaboratorData[this.currentTab.toLowerCase()].splice(i,1);
                    }
                }
            });
        };

        let confirmResult = () => {
            removeCollaborators();
            this.saveCollaborators();
        };
        if (this.isClipCollaborators) {
            removeCollaborators();
            this.currentGridOptions.data = this.collaboratorData.actors;
            this.setDirtyFctn();
        } else {
            let message = 'Are you sure you want to delete Collaborator Role(s)? ';
            let title = 'Delete Collaborator Role(s)?';

            openConfirmModal(message, title, confirmResult);
        }
    };

    this.saveCollaborators = () => {
        this.loadingIndicator.show = true;
        let collabType = this.currentTab.toLowerCase();
        let newCollaboratorPromise = PackageResourceFactory.saveCollaborators({id: queryId, sub: collabType}, this.collaboratorData[collabType]).$promise;

        newCollaboratorPromise.then((collaborators: JS5Object[]) => {
            this.collaboratorData[collabType] = collaborators;
            handleGridDataQuery(this.collaboratorData.actors.concat(this.collaboratorData.crew));
            this.packageObject.acceptStatus = null;
            this.packageObject.rejectReason = null;
            let packageSavePromise = PackageResourceFactory.save({id: $routeParams.id}, this.packageObject).$promise;
            packageSavePromise.then(() => {
                PackageUtilService.pollForPackageUpdates();
            });
            this.loadingIndicator.show = false;
        });

        return newCollaboratorPromise;
    };

    this.handleNewSelection = (newCollaborators: JS5Object[]) => {
        let collabType = this.currentTab.toLowerCase();
        let confirmResult = () => {
            this.collaboratorData[collabType] = this.collaboratorData[collabType].concat(generateRoles(newCollaborators));
            this.saveCollaborators();
        };

        if (this.isClipCollaborators) {
            this.collaboratorData[collabType] = this.collaboratorData[collabType].concat(newCollaborators);
            this.currentGridOptions.data = this.collaboratorData[collabType];
            this.setDirtyFctn();
        } else {
            let message = 'Are you sure you want to add Collaborator Role(s)? ';
            let title = 'Add Collaborator Role(s)?';
            openConfirmModal(message, title, confirmResult);
        }
    };

    this.filter = (searchText: string) => {
        let searchFields = ['character', 'collaborator.displayName', 'collaborator.nickName', 'collaborator.iMDbNumber'];
        this.currentGridOptions.data = $filter('gridSearch')(this.gridDataCopy, searchText, searchFields);
    };

    this.tabAddDisabledInvalid = () => {
        return !this.disabledFound;
    };

    this.deleteInvalid = () => {
        return this.hasWrite && this.selectedRows.length < 1;
    };

    this.gridRowSelectionChangedHandler = (row: JS5Object) => {
        if(row.isSelected) {
            this.selectedRows.push(row.entity);
        } else {
            let index = this.selectedRows.indexOf(row.entity);
            this.selectedRows.splice(index, 1);
        }
    };

    this.toggleRows = (evt: JS5Object) => {
        if(this.gridApi.selection.selectAll) {
            this.gridApi.selection.clearSelectedRows(evt);
            this.gridApi.selection.selectAll = false;
        } else {
            this.gridApi.selection.selectAllVisibleRows(evt);
            this.gridApi.selection.selectAll = true;
        }

        this.selectedRows = this.gridApi.selection.getSelectedRows();
    };

    this.filterValue = '';
    this.disabledFound = false;
    this.gridDataCopy = [];
    this.selectedRows = [];

    this.$onInit = () => {
        this.loadingIndicator = {
            backdrop: true,
            show: false,
            title: 'Working',
            message: 'Please wait...'
        };

        this.roleTabs = {
          actors: false,
          crew: false
        };

        this.isClipCollaborators = $routeParams.editView === 'liveClip';
        this.currentTab = $location.search().subView || 'Actors';

        if(this.isClipCollaborators) {
            PackageUtilService.subTabSaveFunctions[this.editorFormName] = {
                data: () => this.collaboratorData.actors,
                callback: handleGridDataQuery
            };
            PackageUtilService.subTabRevertFunctions[this.editorFormName] = () => {
                this.collaboratorData.actors = angular.copy(originalCollaborators.actors);
                this.currentGridOptions.data = this.savedCollaboratorsMap.actors;
            };
        }

        setQueryProperties();
        getEditData();
        PackageUtilService.tabNewFunction = this.addCollaborator;
        PackageUtilService.tabDeleteFunction = this.deleteCollaborator;
        PackageUtilService.tabAddDisabledFunction = this.addDisabledCollaborator;
        PackageUtilService.tabAddDisabledInvalid = this.tabAddDisabledInvalid;
        PackageUtilService.tabDeleteInvalid = this.deleteInvalid;
        NavbarUtilService.viewSearchFunction = this.filter;
        SearchFilterService.populateCriteriaFromLocationSearch();
    };

    this.$postLink = () => {
        $timeout(() => {
            if(this.isClipCollaborators) {
                PackageUtilService.editorForm = PackageLiveClipViewService[this.editorFormName];
            } else {
                PackageUtilService.editorForm = this.packageCollaboratorsEditorForm;
            }
        });
    };

    this.$onDestroy = () => {
        $location.search('subView', null);
        NavbarUtilService.viewSearchFunction = null;
        if (this.isClipCollaborators && this.editorFormName) {
            delete PackageUtilService.subTabSaveFunctions[this.editorFormName];
            delete PackageUtilService.subTabRevertFunctions[this.editorFormName];
        }
    };
}

angular.module('prism-ui.package').component('packageCollaboratorsView', {
    templateUrl: 'package/editor/components/view/collaborator/packagecollaborators-view-template.html',
    controller: PackageCollaboratorsViewController,
    bindings: {
        packageObject: '=',
        editorFormName: '=',
        setDirtyFctn: '=',
        statusAllowsEdit: '&'
    },
    transclude: true,
    require: {
        pkgLiveClip: '?^packageLiveclipView',
    }
});
